import { render, staticRenderFns } from "./ChargeForm.vue?vue&type=template&id=135ac7c8&scoped=true&"
import script from "./ChargeForm.vue?vue&type=script&lang=js&"
export * from "./ChargeForm.vue?vue&type=script&lang=js&"
import style0 from "./ChargeForm.vue?vue&type=style&index=0&id=135ac7c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135ac7c8",
  null
  
)

export default component.exports